import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { FormattedMessage } from '../../i18n/FormattedMessage';
import ToolTip from '../../components/ToolTip';
import { InfoIcon } from '../AriesIcons';

/**
 * AriesTable header label. Supports an optional `infoTip` (i18n id) rendered
 * as an info icon with a tooltip next to the title, and an optional
 * `defaultMessage` for dot-notation title ids.
 */
const AriesHeaderLabel = ({ header, index, intl }) => (
  <span className="aries-table-head-label">
    <FormattedMessage
      id={header.title}
      defaultMessage={header.defaultMessage || header.title}
    />
    {header.infoTip && (
      <>
        <span
          className="aries-table-head-info"
          data-tip={intl.formatMessage({ id: header.infoTip })}
          data-for={`aries-table-head-info-${index}`}
        >
          <InfoIcon size={14} />
        </span>
        <ToolTip id={`aries-table-head-info-${index}`} place="bottom" />
      </>
    )}
  </span>
);

AriesHeaderLabel.propTypes = {
  header: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(AriesHeaderLabel);
